<template>
		<div class="modal delivery-form" :class="step === 'WaitingOrder' ? 'modal--xs' : 'modal--sm'">
			<div class="modal-close" @click="$emit('close')"></div>
			<div v-if="step === 'WaitingOrder'" class="delivery-form__step">
				<div class="modal-form__title">Заказ услуги «Деньги на дом»</div>
				<div class="delivery-form__message">
					<div class="messages">
						<div class="messages__item"> 
							<p>Теперь не нужно выходить из дома, чтобы оформить заем, деньги сами к вам приедут с нашим курьером-оценщиком.</p>
						</div>
						<div class="messages__item">
							<p>Он сделает финальную оценку залога, оформит договор займа, перечислит деньги на карту и застрахует ваш залог перед тем, как отвезти на хранение. Законно. Удобно. Безопасно.</p>
						</div>
					</div>
				</div>
				<div class="delivery-form__description">Данная услуга доступна только для жителей городов в <a href="/upload/accept_citites_money_to_home.pdf" target="_blank"><span>списке</span></a>, но скоро появится и в других городах. (услуга бесплатна и доступна при стоимости залога от 5 000 р.)</div>
				<button class="btn color shadow" @click.prevent="step = 'StepOne'">
					Перейти к оформлению
				</button>
			</div>

			<div v-if="step === 'StepOne'" class="delivery-form__step">
				<div class="delivery-form__top">
					<div class="delivery-form__top-title">Заказ услуги "Деньги на дом"</div>
					<div class="delivery-form__top-step"><span>Шаг: 01 /</span> 03</div>
				</div>
				<div class="delivery-form__title"> Желаемая сумма и срок</div>
				
				<div class="delivery-form__sum">
					<ul class="evaluate-loan__steps">
						<li class="e-step">
							<div class="e-step__top">
								<div class="e-step__top-title">Желаемая сумма займа</div>
							</div>
							<div class="e-step__content">
								<div class="range-block">
									<div class="default-input">
										<label class="default-input__label">Мне нужно</label>
										<div class="default-input__input">
											<input v-model="formData.max_loan" type="text" v-mask="{
												name: 'currency',
												options: {
												groupSeparator: ' ',
												autoGroup: true,
												suffix: ' руб.',
												prefix: 'от ',
												rightAlign: false,
												placeholder: '_',
												digits: 0,
												min: 10,
												autoUnmask: true
												}}" :placeholder="`от ${preScores.loan.max} руб.`">
										</div>
									</div>
									<Slider :tooltips="false" :lazy="false" v-model="formData.max_loan" :min="preScores.loan.min" :max="preScores.loan.max"/>
								</div>
							</div>
						</li>
						<li class="e-step">
							<div class="e-step__top">
								<div class="e-step__top-title">Желаемый срок займа</div>
							</div>
							<div class="e-step__content">
								<div class="range-block">
									<div class="default-input">
										<label class="default-input__label">На срок</label>
										<div class="default-input__input">
											<input v-model="formData.max_term" type="text" ref="termSum"
													:placeholder="`до ${preScores.term.max} дней`" v-mask="{
															name: 'numeric',
															options: {
																prefix: 'до ',
																suffix: ' дней',
																rightAlign: false,
																placeholder: '_',
																digits: 0,
																min: this.preScores['term']['min'],
																autoUnmask: true,
															}
														}">
										</div>
									</div>
									<Slider :tooltips="false" :lazy="false" v-model="formData.max_term" :min="preScores.term.min" :max="preScores.term.max"/>
								</div>
							</div>
						</li>                       
					</ul>
				</div>
				<button class="btn color shadow" @click.prevent="step = 'StepTwo', this.loadInitials()">
					Продолжить
				</button>            
			</div>            
			<div v-if="step === 'StepTwo'" class="delivery-form__step">
				<div class="delivery-form__top">
					<div class="delivery-form__top-title">Заказ услуги "Деньги на дом"</div>
					<div class="delivery-form__top-step"><span>Шаг: 02 /</span> 03</div>
				</div>
				<div class="delivery-form__title">Предмет залога</div>
				
				<div class="delivery-form__sum">
					<ul class="evaluate-loan__steps">
						<li class="e-step e-step--1">
							<div class="e-step__top">
								<div class="e-step__top-title">Предмет залога<span class="red-text">*</span></div>                 
							</div>
							<div class="e-step__content e-step__content--1">                      
								<div class="l-property">
									<div class="l-property__list">
										<div class="l-property__item"
												v-for="(item, index) in preScores.accept_types"
												:class="[{active :  formData.type_item_id === String(item.id)},{hide : !showMore && index > 5}]"
												:key="item.id" @click="formData.type_item_id = String(item.id)">
											<div class="l-property__wrap">
												<div class="l-property__item-img">
													<img :src="item.icon" loading="lazy" alt="">
												</div>
												<div class="l-property__item-title">{{ item.name }}</div>
											</div>
										</div>
									</div>
									
									<div class="l-property__more" v-if="preScores.accept_types.length > 6" @click="showMore = true" :class="{open : showMore}"></div>
								</div>

								<div class="l-data">
									<div class="default-input">
										<label class="default-input__label">Опишите предмет залога и укажите его характеристики *</label>
										<div class="default-input__input">
											<input v-model="formData.description" type="text" placeholder="Опишите предмет залога">
										</div>
									</div>
								</div>                                
							</div>
						</li>   
						<li class="e-step">
							<div class="e-step__top">
								<div class="e-step__top-title">
									<span>Сделайте фото для оценки</span>
									<span class="red-text">*</span>
								</div>
							</div>
							<div class="e-step__content">
								<div class="l-step__file">
									<div class="default-file">
										<div class="default-file__input">
											<div class="default-file__input-title">Прикрепить фото</div>
											<input class="default-file__input-input" ref="photoInput"
													:disabled="formData.photos.length >= preScores.files.max_count"
													@change="setFiles" multiple :accept="preScores.file_ext" type="file">
										</div>
									</div>
								</div>
								<div class="l-step__preview">
									<div class="preview">
										<div class="preview-img" v-for="(photo,index) in formData.photos" :key="index"
												:style="`background-image: url(${previewUrl(photo)})`">
											<span @click.stop="formData.photos = formData.photos.filter((item,ind) => ind !== index)"></span>
										</div>
										<div class="preview-add"
												v-if="formData.photos.length && formData.photos.length < preScores.files.max_count"
												@click="$refs.photoInput.click()"></div>
									</div>
								</div>
							</div>
						</li>                                                       
					</ul>
				</div>

				<button class="btn color shadow" @click.prevent="validateTwoStep">
					Продолжить
				</button>            
			</div>
			
			<div v-if="step === 'StepThree'" class="delivery-form__step">
				<div class="delivery-form__top">
					<div class="delivery-form__top-title">Заказ услуги "Деньги на дом"</div>
					<div class="delivery-form__top-step"><span>Шаг: 03 /</span> 03</div>
				</div>
				<div class="delivery-form__title">Ваши данные</div>
				<form class="form order-form">
					<div class="form__inputs form__inputs--2">
						<div class="form__inputs-input"> 
							<div class="default-input">
								<label class="default-input__label" for="dform-surname">Фамилия</label>
								<div class="default-input__input"
									:class="{'default-input__input--error' : v$.formData.last_name.$errors.length}">
									<input v-model="formData.last_name" type="text" inputmode="text" id="dform-surname"
										placeholder="Иванов" tabindex="0">
								</div>
								<div v-if="v$.formData.last_name.$errors.length" class="default-input__error">
									<span v-for="(error, index) in v$.formData.last_name.$errors"
										:key="index">{{ error.$message }}</span>
								</div>
							</div>
						</div>
						<div class="form__inputs-input">
							<div class="default-input">
								<label class="default-input__label" for="dform-name">Имя</label>
								<div class="default-input__input"
									:class="{'default-input__input--error' : v$.formData.name.$errors.length}">
									<input v-model="formData.name" type="text" inputmode="text" id="dform-name"
										placeholder="Иван" tabindex="0">
								</div>
								<div v-if="v$.formData.name.$errors.length" class="default-input__error">
									<span v-for="(error, index) in v$.formData.name.$errors" :key="index">{{
											error.$message
										}}</span>
								</div>
							</div>
						</div>
						<div class="form__inputs-input">
							<div class="default-input">
								<label class="default-input__label" for="dform-email">E-mail</label>
								<div class="default-input__input"
									:class="{'default-input__input--error' : v$.formData.email.$errors.length}">
									<input v-model="formData.email" type="email" inputmode="email" id="dform-email"
										placeholder="mail@gmail.com" tabindex="0">
								</div>
								<div v-if="v$.formData.email.$errors.length" class="default-input__error">
									<span v-for="(error, index) in v$.formData.email.$errors" :key="index">{{
											error.$message
										}}</span>
								</div>
							</div>
						</div>
						<div class="form__inputs-input">
							<div class="default-input">
								<label class="default-input__label" for="dform-phone">Номер телефона</label>
								<div class="default-input__input"
									:class="{'default-input__input--error' : v$.formData.phone.$errors.length}">
									<input v-model="formData.phone" type="tel" ref="inputPhone"
										placeholder="+7 (999) 549 34 95" id="dform-phone" inputmode="text" tabindex="0">
								</div>
								<div v-if="v$.formData.phone.$errors.length" class="default-input__error">
									<span v-for="(error, index) in v$.formData.phone.$errors" :key="index">{{
											error.$message
										}}</span>
								</div>
							</div>
						</div>
						<div v-if="citiesList.length" class="form__inputs-input">
							<div class="default-input">
								<label class="default-input__label" for="dform-city">Город</label>
								<div class="default-input__select"
									:class="{'default-input__select--error' : v$.formData.city.$errors.length}">
									<Multiselect id="dform-city" @click.stop @mousedown.stop ref="multiselect"
												:placeholder="'Выберите город'" :can-clear="false" :can-deselect="false"
												v-model="formData.city" :label="'name'" :no-results-text="'Город не найден'"  :searchable="true" :value-prop="'id'"
												:options="citiesList">
										<template #placeholder>
											<div class="multiselect-placeholder"><span>Выберите город</span></div>
										</template>
									</Multiselect>
								</div>
								<div v-if="v$.formData.city.$errors.length" class="default-input__error">
									<span v-for="(error, index) in v$.formData.city.$errors" :key="index">{{
											error.$message
										}}</span>
								</div>
							</div>
						</div>
						<div class="form__inputs-input" v-if="formData.city">
							<div class="default-input">
								<label class="default-input__label" for="dform-address">Адрес</label>
								<div class="default-input__input"
									:class="{'default-input__input--error' : v$.formData.address.$errors.length}">
									<input v-model="formData.address" type="text" placeholder="Введите адрес"
										id="dform-address" inputmode="text" tabindex="0">
								</div>
								<div v-if="v$.formData.address.$errors.length" class="default-input__error">
									<span v-for="(error, index) in v$.formData.address.$errors"
										:key="index">{{ error.$message }}</span>
								</div>
							</div>
						</div>
						<div class="form__inputs-input" v-if="formData.city && formData.address">
							<div class="default-input default-input--date">
								<label class="default-input__label" for="dform-date">Желаемая дата вызова</label>
								<div class="default-input__input default-input__input--date"
									:class="{'default-input__input--error' : v$.formData.date.$errors.length}">
									<v-date-picker color="red" :min-date="new Date()" class="date-calendar"
												:masks="{input: 'DD.MM.YYYY'}" v-model="formData.date">
										<template v-slot="{ inputValue, inputEvents }">
											<input :value="inputValue" v-on="inputEvents" id="dform-date"
												placeholder="дд.мм.гггг"/>
										</template>
									</v-date-picker>
								</div>
								<div v-if="v$.formData.date.$errors.length" class="default-input__error">
									<span v-for="(error, index) in v$.formData.date.$errors" :key="index">{{
											error.$message
										}}</span>
								</div>
							</div>
						</div>
						<!-- <div class="form__inputs-input" v-if="formData.city && formData.address">
							<div class="default-input">
								<label class="default-input__label" for="dform-time">Желаемое время вызова</label>
								<div class="default-input__select"
									:class="{'default-input__select--error' : v$.formData.interval.$errors.length}">
									<Multiselect id="dform-time" :disabled="!formData.date || !formData.city" @click.stop @mousedown.stop
												ref="multiselect" :placeholder="'Выберите время'"
												v-model="formData.interval" :label="'name'" :value-prop="'id'"
												:disabled-prop="'is_disabled'"
												:options="freeTimeList">
										<template #placeholder>
											<div class="multiselect-placeholder"><span>Выберите время</span></div>
										</template>
									</Multiselect>
								</div>
								<div v-if="v$.formData.interval.$errors.length" class="default-input__error">
									<span v-for="(error, index) in v$.formData.interval.$errors"
										:key="index">{{ error.$message }}</span>
								</div>
							</div>
						</div> -->
					</div>
					<div class="form__submit">
						<div class="form__submit-btn">
							<button class="btn color shadow" tabindex="0" :disabled="loading" @click.prevent="sendForm">
								Отправить
							</button>
						</div>
						<div class="form__submit-text">Нажимая кнопку, Вы даете информированное <a
								:href="documents['personal-data']" target="_blank">согласие</a>на обработку своих <a
								:href="documents['policy']" target="_blank">персональных данных</a></div>
					</div>
				</form>
			</div>
		</div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import {required, helpers, email, maxLength} from '@vuelidate/validators'
import Inputmask from "inputmask";
import Fetch from "@/utils/Fetch";
import Multiselect from "@vueform/multiselect"
import objectToFormData from "@/utils/ObjectToFormData";
import {setCookie, getCookie} from "@/utils/Cookie";
import {mapActions, mapGetters, mapMutations} from "vuex";
import executeRecaptcha from "@/utils/ExecuteRecaptcha";
import Slider from "@vueform/slider"

const {withMessage} = helpers
export default {
	name: "PopupMoneyDelivery",
	components: {Multiselect, Slider},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	props: {
		stepInitial: {
			type: String,
			default: "WaitingOrder"
		}
	},
	data() {
		return {
			step: "WaitingOrder",
			loading: false,
			showMore: false,
			formData: {
				last_name: getCookie('userLastUsedSurname') || '',
				name: getCookie('userLastUsedSelfName') || '',
				email: getCookie('userLastUsedEmail') || '',
				phone: getCookie('userLastUsedPhone') || '',
				address: getCookie('userLastUsedAddress') || '',
				date: new Date(),
				city: '',
				interval: '',
				type_item_id: 0,
				max_loan: 5000,
				max_term: 20,
				photos: [],
				description: '',
			},
		}
	},
	validations() {
		return {
			formData: {
				last_name: {
					required: withMessage('Необходимо указать фамилию', required),
					maxLength: withMessage('Максимальная длина поля 50 символов', maxLength(50)),
				},
				name: {
					required: withMessage('Необходимо указать имя', required),
					maxLength: withMessage('Максимальная длина поля 50 символов', maxLength(50)),
				},
				phone: {
					required: withMessage('Необходимо указать телефон', required),
					maxLength: withMessage('Максимальная длина поля 50 символов', maxLength(50)),
				},
				email: {
					email: withMessage('Неверный формат электронной почты', email),
					required: withMessage('Необходимо указать E-mail', required),
					maxLength: withMessage('Максимальная длина поля 100 символов', maxLength(100)),
				},
				address: {required: withMessage('Необходимо указать адрес', required)},
				city: {required: withMessage('Необходимо выбрать город', required)},
				date: {required: withMessage('Необходимо выбрать дату', required)},
				// interval: {required: withMessage('Необходимо выбрать время', required)},
			},
		}
	},
	mounted() {
		this.step = this.stepInitial
	},
	watch: {
		'formData.date': async function (newValue) {
			if (newValue) {
				if (this.formData.city) await this.loadFreeTime({date: newValue.toISOString(), city: this.formData.city})
			}
		},
		'formData.city': async function (newValue) {
			if (newValue) {
				if (this.formData.date) await this.loadFreeTime({city: newValue, date: this.formData.date.toISOString()})
			}
		},
		step: function (newValue) {
			if (newValue === 'StepThree') {
				setTimeout(() => {
					Inputmask('+7 (999) 999 99 99').mask(this.$refs.inputPhone)
				}, 500)
			}
		}
	},
	computed: {
		freeTimeList() {
			if (this.formData.date.toLocaleDateString() === new Date().toLocaleDateString()) {
				return Array.from(this.getFreeTimeList).map(item => {
					let timeTo = item.name.valueOf().split('-')[1].trim().split(':')[0] || null
					if (timeTo) {
						if (new Date().getHours() >= timeTo) {
							item.is_disabled = true
						}
					}
					return item
				})
			} else {
				return this.getFreeTimeList
			}
		},
		previewUrl() {
			return (photo) => URL.createObjectURL(photo)
		},
		...mapGetters({
			getFreeTimeList: 'moneyDelivery/getFreeTime',
			documents: 'getDocuments',
			citiesList: 'moneyDelivery/getCitiesList',
			getModalOpened: 'modals/getModalOpened',
			isModalOpened: 'modals/isModalOpened',
			preScores: 'estimate/getPreScoreInitials',
		})
	},
	methods: {
		async sendForm() {
			this.loading = true
			const result = await this.v$.formData.$validate()
			if (!result) {
				this.loading = false
				return
			}
			
			let token 
			await executeRecaptcha().then(async (tokenRecaptcha) => token = tokenRecaptcha)

			let body = objectToFormData({
				last_name: this.formData.last_name,
				name: this.formData.name,
				email: this.formData.email,
				phone: this.formData.phone,
				address: this.formData.address,
				date: this.formData.date.toISOString(),
				cityId: this.formData.city,
				// interval: this.formData.interval,
				type_item_id: this.formData.type_item_id,
				max_loan: this.formData.max_loan,
				max_term: this.formData.max_term,
				'photos': this.formData.photos,
				description: this.formData.description,
				token
			})

			let response = await Fetch('forms/money-home/', {
				method: 'POST',
				body
			})
			if (response.success) {
				this.setSuccess({title: 'Услуга заказана!', message: response.message})
			} else {
				this.setSuccess({title: 'Что-то пошло не так!', message: response.message})
			}
			this.loading = false

			setCookie('userLastUsedSelfName', this.formData.name)
			setCookie('userLastUsedSurname', this.formData.last_name)
			setCookie('userLastUsedEmail', this.formData.email)
			setCookie('userLastUsedAddress', this.formData.address)
			setCookie('userLastUsedPhone', this.formData.phone)

			window.fancyboxConstructor.show([{src: "#popup-success", type: "inline"}], {
				Toolbar: false,
				dragToClose: false,
				Thumbs: false,
				closeButton: "top",
				mainClass: "fancybox-modal",
				on: {
					closing: () => {
						if (response.success) {
							this.closeModal('delivery-form')
						}
					}
				}
			})
		},

		async validateTwoStep() {
			const result = this.formData.type_item_id && this.formData.photos.length > 0 && this.formData.description
			if (!result) {
				window.toast.error('Необходимо заполнить все обязательные поля')
				return
			}
			this.step = 'StepThree'
		},


		setFiles(e) {
			let fileList = Array.from(e.target.files)
			fileList.filter((file) => file.size <= (this.preScores.files.max_size * 1000))
			this.formData.photos = this.formData.photos.concat(fileList)
			if (this.formData.photos.length > 10) {
				this.formData.photos.length = 10
			}
		},
		...mapActions({
			loadFreeTime: 'moneyDelivery/loadFreeTime',
			loadInitials: 'moneyDelivery/loadInitialData',
			closeModal: 'modals/closeModal',

		}),
		...mapMutations({
			setSuccess: 'setPopupSuccessData'
		})
	}
}
</script>

<style scoped>

</style>
